import React from 'react';
import * as Styles from './ContinueWithTemplateModal.styles';
import { Button, Modal } from 'gatorcomponents';

const ContinueWithTemplateModal = ({
  onCloseModal,
  openTemplate,
  locales,
  trackingEvents,
}) => {
  const handleOpenTemplate = () => {
    trackingEvents && trackingEvents.clickIWantThisTemplate();
    openTemplate && openTemplate();
  };

  return (
    <Modal testId="continue-with-template-modal">
      <Styles.Wrapper>
        <Styles.Title>{locales.title}</Styles.Title>

        <Styles.Description>{locales.description}</Styles.Description>

        <Styles.ButtonsWrapper>
          <Button
            testId="continue-with-template-modal-close-button"
            onClick={onCloseModal}
            label={locales.changeTemplateButtonLabel}
            size="medium2"
            variant="tertiary"
          />

          <Button
            testId="continue-with-template-modal-open-template-button"
            onClick={handleOpenTemplate}
            label={locales.continueButtonLabel}
            size="medium2"
          />
        </Styles.ButtonsWrapper>
      </Styles.Wrapper>
    </Modal>
  );
};

export default ContinueWithTemplateModal;
